module.exports = __webpack_public_path__ + "static/media/image_89.f499c0db.png";